import script from "./CatalogoBuscador.vue?vue&type=script&setup=true&lang=js"
export * from "./CatalogoBuscador.vue?vue&type=script&setup=true&lang=js"

import "./CatalogoBuscador.vue?vue&type=style&index=0&id=53966568&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53966568"]])

export default __exports__